import CreatorsRoutes from "./pages/creators.routes";
import LicenseesRoutes from "./pages/licensees.routes";
import AdminRoutes from "./pages/admin.routes";
import FixiterRoutes from "./pages/fixiter.routes";
import OpenPagesRoutes from "./pages/openPages.routes";
import { Fragment } from "react";
import AuthGuard from "./AuthGuard";
import { PrinterProvider } from "../hooks/PrintersContext";
import { OnboardProvider } from "../hooks/OnboardContext";
import { TipsProvider } from "../hooks/TipsContext";
import { WebSocketProvider } from "../hooks/PrinterWebSocketContext";
import { FinancialStatusProvider } from "../hooks/FinancialStatusContext";

function Router() {
  return (
    <Fragment>
      <OpenPagesRoutes />
      <OnboardProvider>
        <AuthGuard>
          <WebSocketProvider>
            <TipsProvider>
              <PrinterProvider>
                <FinancialStatusProvider>
                  <Fragment>
                    <AdminRoutes />
                    <CreatorsRoutes />
                    <FixiterRoutes />
                    <LicenseesRoutes />
                  </Fragment>
                </FinancialStatusProvider>
              </PrinterProvider>
            </TipsProvider>
          </WebSocketProvider>
        </AuthGuard>
      </OnboardProvider>
    </Fragment>
  );
}

export default Router;
